import { useEffect, useState, useRef } from "react";
import { LanguageProvider, useLanguage } from "../LanguageContext";
import { Globe, Check } from "lucide-react";
import "../AfterSalesService.css";

const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "ch", label: "中文" },
  { code: "my", label: "Bahasa Malaysia" },
];

const PreviewLayout = ({ children }) => {
  const { lang, setLanguage } = useLanguage();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    document.body.classList.add("as-aftersales-body");
    return () => document.body.classList.remove("as-aftersales-body");
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="as-aftersales">
      <div className="as-aftersales-top">
        <div className="as-aftersales-brand-logo">BRAND LOGO</div>

        {/* Language Dropdown */}
        <div className="as-aftersales-lang-switcher" ref={dropdownRef}>
          <button
            className="as-lang-globe-btn"
            onClick={() => setDropdownOpen((prev) => !prev)}
            aria-label="Select language"
          >
            <Globe size={20} />
          </button>
          {dropdownOpen && (
            <div className="as-lang-dropdown">
              {LANGUAGES.map(({ code, label }) => (
                <div
                  key={code}
                  className={`as-lang-option ${lang === code ? "as-active" : ""}`}
                  onClick={() => {
                    setLanguage(code);
                    setDropdownOpen(false);
                  }}
                >
                  <span>{label}</span>
                  {lang === code && <Check size={16} />}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="as-aftersales-bottom">{children}</div>
    </div>
  );
};

export default PreviewLayout;
